<script>
import dateMixin from '@/mixins/dateMixin';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/fr';

export default {
  mixins: [dateMixin],
  components: {
    DatePicker,
  },
  props: {
    defaultValue: { type: [Date, String], default: null },
    returnedObject: { default: null },
    target: { type: String, required: true },
    placement: { type: String, default: 'top' },
  },
  data() {
    return {
      currentValue: '',
    };
  },
  methods: {
    closePopover() {
      this.$refs[this.target + '-popover'].$emit('close');
    },
    showPopover() {
      this.currentValue = this.defaultValue;
    },
    popoverShown() {
      this.$refs[`${this.target}-input`].focus();
    },
    saveEditedQuantity() {
      this.$emit('set-edited-date', this.currentValue, this.returnedObject);
      this.closePopover();
    },
  },
};
</script>

<template>
  <b-popover
    :ref="target + '-popover'"
    :target="target"
    triggers="click"
    :placement="placement"
    @show="showPopover"
    @shown="popoverShown"
  >
    <template #title>
      <div class="flex-box">
        <div>{{ $t('general.editDate') }}</div>
        <div class="flex-push pl-3">
          <i
            class="fas fa-times text-secondary pl-2 pr-2"
            @click="closePopover()"
            style="cursor: pointer; font-size: 1.3em"
          ></i>
        </div>
      </div>
    </template>
    <div>
      <date-picker
        v-model="currentValue"
        :ref="`${target}-input`"
        @pick="saveEditedQuantity"
        :first-day-of-week="1"
        format="YYYY-MM-DD"
        value-type="format"
        style="font-size: 1.1em"
        :lang="$i18n.locale"
      >
      </date-picker>

      <b-button style="margin-top: 10px" block @click="saveEditedQuantity()">{{
        $t('general.update')
      }}</b-button>
    </div>
  </b-popover>
</template>
